/**
 * FFE Equipment Guidance - SIMPLIFIED DIRECT SYSTEM
 * Every requirement ID maps directly to guidance - NO MAPPINGS, NO COMPLEXITY
 * Based on Regulations Assistant verified guidance
 */

import { FFE_SIMPLE_GUIDANCE, getFFESimpleGuidance } from './ffe.simple.js';
import { FFE_ADDITIONAL_GUIDANCE } from './ffe.additional.js';

/**
 * Simple Direct FFE Guidance - NO MAPPINGS
 * @param {string} itemId - Equipment requirement ID
 * @returns {Object|null} Guidance object or null
 */
export function getFFEGuidance(itemId) {
  // First check additional guidance for specific equipment register IDs
  if (FFE_ADDITIONAL_GUIDANCE[itemId]) {
    return FFE_ADDITIONAL_GUIDANCE[itemId];
  }
  
  // Then check main RA-verified guidance
  return getFFESimpleGuidance(itemId);
}

// Combined guidance for compatibility
const COMBINED_FFE_GUIDANCE = {
  ...FFE_SIMPLE_GUIDANCE,
  ...FFE_ADDITIONAL_GUIDANCE
};

export { COMBINED_FFE_GUIDANCE as FFE_GUIDANCE };